import React from "react";
import Drum from "../Drum"
import "./App.css"

const App = () => {
  return <div id="App"><Drum/></div>;
};

export default App;
